import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'dayjs/locale/ru';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import ru from 'element-plus/es/locale/lang/ru';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import VueTheMask from 'vue-the-mask';
import { initYandexMetrika } from 'yandex-metrika-vue3';
import App from './App/App.vue';
import router from './router';

const pinia = createPinia();
const app = createApp(App);

app.use(ElementPlus, {
  locale: ru,
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(router);
app.use(VueTheMask);

app.directive('cancelReadOnly', (el) => {
  // const input = el.querySelector('.el-input__inner');
  // input.removeAttribute('readonly');
});

app.use(pinia);

app.use(initYandexMetrika, {
  id: 95480767,
  router: router,
  env: process.env.NODE_ENV,
  debug: true,
  // other options
});

app.mount('#app');
